import { useState, useEffect } from "react";
import axios from "axios";

const Product = () => {
  const [productData, setProductData] = useState({
    product_name: "",
    category: "",
    pricePerKg: "",
    description: "",
  });

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [products, setProducts] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  const API_BASE = "http://localhost:8000/polaragro/product"; // change this to your server

  // Fetch products from backend
  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${API_BASE}/getproduct`);
      setProducts(response.data.products || []);
    } catch (error) {
      console.error("Error fetching products:", error.message);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle image file selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  // Add or Update product
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { product_name, category, pricePerKg, description } = productData;

    if (!product_name || !pricePerKg) {
      alert("Please fill in required fields.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("product_name", product_name);
      formData.append("category", category);
      formData.append("pricePerKg", pricePerKg);
      formData.append("description", description);
      if (image) formData.append("imagefile", image); // Must match multer field name

      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      if (isEditing) {
        await axios.put(
          `${API_BASE}/updateproduct?id=${editId}`,
          formData,
          config
        );
        setIsEditing(false);
        setEditId(null);
      } else {
        await axios.post(`${API_BASE}/addproduct`, formData, config);
      }

      // Reset form
      setProductData({
        product_name: "",
        category: "",
        pricePerKg: "",
        description: "",
        image: ""
      });
      setImage(null);
      setPreview(null);
      fetchProducts();
    } catch (error) {
      console.error("Error saving product:", error.message);
      alert("Failed to save product.");
    }
  };

  // Set product data for editing
  const handleEdit = async (product) => {
  setProductData({
    product_name: product.product_name,
    category: product.category,
    pricePerKg: product.pricePerKg,
    description: product.description,
    image: product.fileUrl,
  });
  setIsEditing(true);
  setEditId(product._id);

  try {
    const res = await axios.get(`${API_BASE}/imagefile?id=${product._id}`, {
      responseType: "blob",
    });

    const imageBlob = res.data;
    const imageURL = URL.createObjectURL(imageBlob);
    setPreview(imageURL);
  } catch (error) {
    console.error("Error loading image preview:", error.message);
    setPreview(null);
  }
};


  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Product Management</h1>

      {/* Product Form */}
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow p-4 rounded mb-6 space-y-4"
        encType="multipart/form-data"
      >
        <input
          name="product_name"
          placeholder="Product Name"
          value={productData.product_name}
          onChange={handleChange}
          className="border border-gray-300 rounded p-2 w-full"
          required
        />
        <input
          name="category"
          placeholder="Category"
          value={productData.category}
          onChange={handleChange}
          className="border border-gray-300 rounded p-2 w-full"
        />
        <input
          name="pricePerKg"
          type="number"
          placeholder="Price per Kg"
          value={productData.pricePerKg}
          onChange={handleChange}
          className="border border-gray-300 rounded p-2 w-full"
          required
        />
        <textarea
          name="description"
          placeholder="Description"
          value={productData.description}
          onChange={handleChange}
          className="border border-gray-300 rounded p-2 w-full"
          rows="3"
        />

        {/* Image Upload */}
        <input
          type="file"
          accept="imagefile/*"
          onChange={handleImageChange}
          className="border border-gray-300 rounded p-2 w-full"
        />
        {preview && (
          <img
            src={preview}
            alt="Preview"
            className="w-32 h-32 object-cover rounded border mt-2"
          />
        )}

        <button
          type="submit"
          className={`w-full ${
            isEditing
              ? "bg-yellow-500 hover:bg-yellow-600"
              : "bg-green-600 hover:bg-green-700"
          } text-white py-2 px-4 rounded transition duration-200`}
        >
          {isEditing ? "Update Product" : "Add Product"}
        </button>
      </form>

      {/* Products Table */}
      {products.length > 0 && (
        <table className="min-w-full bg-white shadow rounded">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-center p-3">Image</th>
              <th className="text-center p-3">Code</th>
              <th className="text-center p-3">Product</th>
              <th className="text-center p-3">Category</th>
              <th className="text-center p-3">Price</th>
              <th className="text-center p-3">Description</th>
              <th className="text-center p-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p._id} className="border-t text-center">
                <td className="p-3">
                  <img
                    src={p.fileUrl}
                    // alt="Product"
                    className="w-20 h-20 object-cover mx-auto rounded"
                  />
                  {console.log(p.fileUrl)
                  }
                </td>
                <td className="p-3">{p.code || "—"}</td>
                <td className="p-3">{p.product_name}</td>
                <td className="p-3">{p.category}</td>
                <td className="p-3">{p.pricePerKg}</td>
                <td className="p-3">{p.description}</td>
                <td className="p-3 flex justify-center gap-2">
                  <button
                    onClick={() => handleEdit(p)}
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 text-sm"
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Product;
